import { Container, Tab, TabPane } from 'semantic-ui-react';
import { SearchTab } from './search-tab';
import { EnrollmentSearchQueryBuilder } from './components/query-builder/EnrollmentSearchQueryBuilder';
import { useState } from 'react';
import { RuleGroupType } from 'react-querybuilder';
import { useTranslation2 } from '../../Contexts/TranslationContext2';
import { BPContainer } from '@/components/bp/bpcontainer';

type EnrollmentSearchProps = {
};


export const EnrollmentSearch: React.FC<EnrollmentSearchProps> = (props) => {
    const { translations: t } = useTranslation2();

    const ruleGroup: RuleGroupType = { combinator: 'and', rules: [{ field: 'firstName', operator: '=', value: '' }] };
    const ruleGroup2: RuleGroupType = { combinator: 'and', rules: [] };

    const [queryStructured, setQueryStructured] = useState<RuleGroupType>(ruleGroup2);
    const [queryFlat, setQueryFlat] = useState<RuleGroupType>(ruleGroup);

    return (
        <BPContainer>
            <Tab renderActiveOnly panes={[
                { menuItem: t.common.search, render: () => <TabPane key='search'><SearchTab /></TabPane> },
                { menuItem: t.metadata.queryBuilderDeep, render: () => <TabPane key='query-builder'><EnrollmentSearchQueryBuilder flattenArrays={false} query={queryStructured} onQueryChange={setQueryStructured} /></TabPane> },
                { menuItem: t.metadata.queryBuilderQuick, render: () => <TabPane key='query-builder-2'><EnrollmentSearchQueryBuilder flattenArrays={true} query={queryFlat} onQueryChange={setQueryFlat} /></TabPane> },
            ]} />
        </BPContainer>
    );
};
